import { render, staticRenderFns } from "./XCheckbox.vue?vue&type=template&id=399468ac&scoped=true&"
import script from "./XCheckbox.vue?vue&type=script&lang=js&"
export * from "./XCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./XCheckbox.vue?vue&type=style&index=0&id=399468ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399468ac",
  null
  
)

export default component.exports